const CURRICULUM = [
  { left: 2, right: 2, teleport10: false, teleport5: false, fatTie: false, bank: false },
  { left: 2, right: 3, teleport10: false, teleport5: false, fatTie: false, bank: false },
  { left: 2, right: 4, teleport10: false, teleport5: false, fatTie: false, bank: false },
  { left: 2, right: 5, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 2, right: 6, teleport10: false, teleport5: false, fatTie: true, bank: true },
  { left: 2, right: 7, teleport10: false, teleport5: false, fatTie: true, bank: true },
  { left: 2, right: 8, teleport10: false, teleport5: false, fatTie: true, bank: true },
  { left: 2, right: 9, teleport10: true, teleport5: false, fatTie: true, bank: true },
  { left: 3, right: 2, teleport10: false, teleport5: false, fatTie: false, bank: false },
  { left: 3, right: 3, teleport10: false, teleport5: false, fatTie: false, bank: false },
  { left: 3, right: 4, teleport10: false, teleport5: true, fatTie: true, bank: false },
  { left: 3, right: 5, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 3, right: 6, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 3, right: 7, teleport10: false, teleport5: false, fatTie: false, bank: true },
  { left: 3, right: 8, teleport10: false, teleport5: false, fatTie: false, bank: true },
  { left: 3, right: 9, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 4, right: 2, teleport10: false, teleport5: false, fatTie: false, bank: false },
  { left: 4, right: 3, teleport10: false, teleport5: true, fatTie: true, bank: false },
  { left: 4, right: 4, teleport10: false, teleport5: true, fatTie: true, bank: false },
  { left: 4, right: 5, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 4, right: 6, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 4, right: 7, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 4, right: 8, teleport10: false, teleport5: false, fatTie: false, bank: true },
  { left: 4, right: 9, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 5, right: 2, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 5, right: 3, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 5, right: 4, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 5, right: 5, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 5, right: 6, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 5, right: 7, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 5, right: 8, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 5, right: 9, teleport10: true, teleport5: false, fatTie: true, bank: true },
  { left: 6, right: 2, teleport10: false, teleport5: false, fatTie: true, bank: true },
  { left: 6, right: 3, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 6, right: 4, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 6, right: 5, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 6, right: 6, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 6, right: 7, teleport10: false, teleport5: true, fatTie: true, bank: false },
  { left: 6, right: 8, teleport10: true, teleport5: false, fatTie: true, bank: false },
  { left: 6, right: 9, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 7, right: 2, teleport10: false, teleport5: false, fatTie: true, bank: true },
  { left: 7, right: 3, teleport10: false, teleport5: false, fatTie: false, bank: true },
  { left: 7, right: 4, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 7, right: 5, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 7, right: 6, teleport10: false, teleport5: true, fatTie: true, bank: false },
  { left: 7, right: 7, teleport10: true, teleport5: false, fatTie: true, bank: false },
  { left: 7, right: 8, teleport10: true, teleport5: false, fatTie: false, bank: false },
  { left: 7, right: 9, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 8, right: 2, teleport10: false, teleport5: false, fatTie: true, bank: true },
  { left: 8, right: 3, teleport10: false, teleport5: false, fatTie: false, bank: true },
  { left: 8, right: 4, teleport10: false, teleport5: false, fatTie: false, bank: true },
  { left: 8, right: 5, teleport10: false, teleport5: false, fatTie: true, bank: false },
  { left: 8, right: 6, teleport10: true, teleport5: false, fatTie: true, bank: false },
  { left: 8, right: 7, teleport10: true, teleport5: false, fatTie: false, bank: false },
  { left: 8, right: 8, teleport10: true, teleport5: false, fatTie: false, bank: false },
  { left: 8, right: 9, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 9, right: 2, teleport10: true, teleport5: false, fatTie: true, bank: true },
  { left: 9, right: 3, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 9, right: 4, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 9, right: 5, teleport10: true, teleport5: false, fatTie: true, bank: true },
  { left: 9, right: 6, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 9, right: 7, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 9, right: 8, teleport10: true, teleport5: false, fatTie: false, bank: true },
  { left: 9, right: 9, teleport10: true, teleport5: false, fatTie: false, bank: true }
];
function findCurriculumEntry(left, right) {
  return CURRICULUM.find((e) => e.left === left && e.right === right);
}
function entryToFeatures(entry) {
  return {
    tie: true,
    teleport5: entry.teleport5,
    teleport10: entry.teleport10,
    bank: entry.bank,
    indicator: true,
    customInput: false
  };
}
const FEATURE_CATEGORIES = [
  { key: "teleport10", moduleId: "teleport10", category: "십텔레포트", color: "border-blue-300 text-blue-700 hover:bg-blue-50", activeColor: "bg-blue-600 text-white border-blue-600", dotColor: "bg-blue-500", description: "→10 / ↓10 줄십 자동 묶기" },
  { key: "teleport5", moduleId: "teleport5", category: "5텔레포트", color: "border-cyan-300 text-cyan-700 hover:bg-cyan-50", activeColor: "bg-cyan-600 text-white border-cyan-600", dotColor: "bg-cyan-500", description: "→5 / ↓5 뚱십 수동 묶기" },
  { key: "fatTie", moduleId: "fatTie", category: "뚱십", color: "border-green-300 text-green-700 hover:bg-green-50", activeColor: "bg-green-600 text-white border-green-600", dotColor: "bg-green-500", description: "2×5 / 5×2 직접 묶기" },
  { key: "bank", moduleId: "bank", category: "은행", color: "border-orange-300 text-orange-700 hover:bg-orange-50", activeColor: "bg-orange-600 text-white border-orange-600", dotColor: "bg-orange-500", description: "빌리기 / 놓기 / 반납" }
];
const FEATURED_PROBLEMS = FEATURE_CATEGORIES.map((cat) => ({
  ...cat,
  problems: CURRICULUM.filter((e) => e[cat.key] === true)
}));
const DOT_COLORS = [
  { key: "teleport10", color: "bg-blue-500", label: "십" },
  { key: "teleport5", color: "bg-cyan-500", label: "5" },
  { key: "fatTie", color: "bg-green-500", label: "뚱" },
  { key: "bank", color: "bg-orange-500", label: "은" }
];
export {
  CURRICULUM,
  DOT_COLORS,
  FEATURED_PROBLEMS,
  FEATURE_CATEGORIES,
  entryToFeatures,
  findCurriculumEntry
};
//# sourceMappingURL=curriculum.js.map
